import { functions } from "../../main";

export async function createHyDryCertificate(projectId: string, folderName: string) {
  const createHyDryCertificate = functions.httpsCallable(
    "createHyDryCertificate"
  );

  return (await createHyDryCertificate({
    projectId,
    folderName,
  })).data;
}